<template>
  <TheNuxtLink
    class="transition-colors select-none rounded-md text-sm font-medium uppercase py-1 px-2 relative overflow-hidden"
    :class="{
      'bg-neutral-200 dark:bg-neutral-800 hover:bg-neutral-300 dark:hover:bg-neutral-700':
        !type || type === 'default',
      'bg-nami-nami-blue text-white hover:bg-nami-comi-blue':
        type === 'primary',
      'bg-nami-comi-blue text-white hover:bg-nami-seafoam':
        type === 'secondary',
      'bg-yellow-400 text-black': type === 'gold',
      'bg-neutral-400 text-black': type === 'silver',
      'bg-red-400 dark:bg-red-600 text-white': type === 'danger',
      'text-xs py-0.5 px-1': realSmall,
      'text-2xs py-[0.125rem] px-1': realXSmall,
    }"
    :href="tagLink"
  >
    <span class="shine" v-if="type === 'gold' || type === 'silver'"></span>
    <span class="z-[3] relative">
      <slot>{{ tag }}</slot>
    </span>
  </TheNuxtLink>
</template>

<script setup lang="ts">
interface Props {
  type?: "default" | "danger" | "primary" | "secondary" | "gold" | "silver";
  tag?: string;
  small?: boolean;
  xSmall?: boolean;
}

const props = defineProps<Props>();
const href = useHref();

const realSmall = inject("small", props.small ?? false);
const realXSmall = inject("xSmall", props.xSmall ?? false);

// TODO: temporary, switched when we get dedicated pages for them
const genreTags = [
  "action",
  "adventure",
  "boys-love",
  "comedy",
  "crime",
  "drama",
  "fantasy",
  "girls-love",
  "historical",
  "horror",
  "isekai",
  "mecha",
  "medical",
  "mystery",
  "philosophical",
  "psychological",
  "romance",
  "sci-fi",
  "slice-of-life",
  "sports",
  "superhero",
  "thriller",
  "tragedy",
  "wuxia",
];
const themeTags = [
  "aliens",
  "animals",
  "cooking",
  "crossdressing",
  "delinquents",
  "demons",
  "genderswap",
  "ghosts",
  "gyaru",
  "harem",
  "mafia",
  "magic",
  "magical-girls",
  "martial-arts",
  "military",
  "monster-girls",
  "monsters",
  "music",
  "ninja",
  "office-workers",
  "police",
  "post-apocalyptic",
  "reincarnation",
  "reverse-harem",
  "samurai",
  "school-life",
  "supernatural",
  "survival",
  "time-travel",
  "traditional-games",
  "vampires",
  "video-games",
  "villainess",
  "virtual-reality",
  "zombies",
];
const contentTags = [
  "drugs",
  "gambling",
  "gore",
  "mental-disorders",
  "physical-abuse",
  "racism",
  "self-harm",
  "sexual-abuse",
  "verbal-abuse",
];

const tagLink = computed(() => {
  if (!props.tag) return;
  if (genreTags.includes(props.tag)) {
    return href.value.discover.tag(props.tag);
  }
  if (themeTags.includes(props.tag)) {
    return href.value.title.search + `?includedThemes=${props.tag}`;
  }
  if (contentTags.includes(props.tag)) {
    return href.value.title.search + `?includedContent=${props.tag}`;
  }
});
</script>

<style scoped lang="postcss">
.text-2xs {
  font-size: 0.625rem;
  line-height: 0.75rem;
}

.shine {
  background: linear-gradient(
    19deg,
    white 0%,
    transparent 40%,
    white 70%,
    transparent 100%
  );
  @apply absolute inset-0 opacity-80;
}
</style>
